import { useEffect } from "react"
import PropTypes from "prop-types"
import parse from "html-react-parser"

import chevronLeftBlack from "images/layout/chevron-left-black.svg?raw"
import StripeJsContainer from "./stripe_js_container"
import PaymentInfoForm from "./payment_info_form"
import paidBenefits from "app/components/subscriptions/shared/paid_benefits"
import ErrorBoundary from "shared/components/error_boundary"
import { saveUserPermissions } from "shared/scripts/new_badge_button"

import styles from "./sign_up_and_purchase.module.scss"

export default function SignUpAndPurchase(props) {
  useEffect(() => {
    if (props.inactiveUserAppletsDisabled) window.App.Utils?.logCustomDatadogAction("inactive_applets_disabled")
    window.App.Utils?.logCustomDatadogAction("stripe_checkout_viewed") // leaving this alone in case other funnels rely on it

    window.App.Utils?.logCustomDatadogAction("stripe_checkout_initial")
    window.App.Utils?.logCustomDatadogAction("stripe_checkout_initial_non_modal")
  }, [])

  const benefits = paidBenefits[props.tier]

  const studentProgramCheckout = props.tier === "pro" && props.userIsStudent

  const onSubscriptionSuccess = (subscription, permissions) => {
    saveUserPermissions(subscription.tier, permissions)
    if (props.redirectToMobileAppOnSuccess) {
      window.location.href = "ifttt://pro_subscription?status=subscribed"
    } else {
      const continueDestination = sessionStorage.getItem("afterProPaymentPath") || props.urls.continuePath
      sessionStorage.removeItem("afterProPaymentPath")
      window.location.href = continueDestination
    }
  }

  return (
    <ErrorBoundary>
      <StripeJsContainer>
        <header className={`${styles["onboarding-header"]} pb2 pb0--phone`}>
          <div className={styles["spacer"]}>
            {!props.renderingInsideModal && (
              <button
                type="submit"
                className="button-tertiary button-outlined button-with-icon only-icon-on-mobile"
                aria-label="Back button"
                data-dd-action-name="Subscription back button"
                onClick={() => {
                  window.history.back()
                }}
              >
                <span className="button-icon">{parse(chevronLeftBlack)}</span>
                <span className="hide-on-xs">Back</span>
              </button>
            )}
          </div>
          <h1>
            <img src={props.assets.iftttSvgUrl} alt="IFTTT logo" width="122" height="37" />
            {props.tier === "pro" ? (
              <img src={props.assets.proPlusBadgeSvgUrl} alt="Pro+ badge" width="91" height="53" />
            ) : (
              <img src={props.assets.proBadgeSvgUrl} alt="Pro badge" width="91" height="53" />
            )}
          </h1>
          <div className={styles["spacer"]} />
        </header>

        <section className={`${styles["benefits"]} welcome`}>
          <ul>
            {benefits.map((benefit, index) => (
              <li key={index}>{benefit}</li>
            ))}
          </ul>
          {props.showWarningForStudents && (
            <p>Students get their first year of Pro+ with 90% off. Verify your email to claim this deal.</p>
          )}
        </section>
        <div className={`flexbox ${styles["payment-info"]}`}>
          <PaymentInfoForm
            {...props}
            studentProgramCheckout={studentProgramCheckout}
            onSubscriptionSuccess={onSubscriptionSuccess}
          />
        </div>
      </StripeJsContainer>
    </ErrorBoundary>
  )
}

SignUpAndPurchase.propTypes = {
  assets: PropTypes.shape({
    iftttSvgUrl: PropTypes.string.isRequired,
    proBadgeSvgUrl: PropTypes.string.isRequired,
    proPlusBadgeSvgUrl: PropTypes.string.isRequired,
  }),
  eligibleForTrial: PropTypes.bool,
  eligibleTrialPeriod: PropTypes.number,
  inactiveUserAppletsDisabled: PropTypes.bool,
  redirectToMobileAppOnSuccess: PropTypes.bool,
  renderingInsideModal: PropTypes.bool.isRequired,
  showWarningForStudents: PropTypes.bool,
  tier: PropTypes.string.isRequired,
  urls: PropTypes.object,
  userIsStudent: PropTypes.bool,
  initialInterval: PropTypes.string,
}

SignUpAndPurchase.defaultProps = {
  renderingInsideModal: false,
  showWarningForStudents: false,
  userIsStudent: false,
}
